import { useSelector } from 'react-redux';
import { getUserSelector } from './user';

export const useUser = () => useSelector(getUserSelector);
